// extracted by mini-css-extract-plugin
export default {"Banner":"Banner_Banner__bBoiG","slideContainer":"Banner_slideContainer__IczoE","goTo":"Banner_goTo__+d53k"};